export { default } from './TypedContent';
